<template>
  <header>
    <img class="left-texture" src="../../../../src/assets/images/pages/university-header-left-texture.svg" align="left"/>
    <img class="leaf-1" src="../../../../src/assets/images/leaves/l12.png" align="left"/>
    <vs-row class="content" vs-type="flex" vs-justify="space-around">
      <vs-col vs-justify="center" vs-align="center" vs-w="5" vs-sm="12">
        <div class="header__content">
          <p class="header__p1 mb-3">Sit back and relax</p>
          <h3 class="header__h3 mb-base">Something Great will happen for your students.</h3>
          <p class="header__p2 mb-3">Request a free demo today</p>
          <vx-input-group class="univ-demo-input sm:w-full">
            <vs-input v-model="input2" placeholder="Your email id"/>
            <template slot="append">
              <div class="append-text btn-addon">
                <vs-button color="#FFFFFF" text-color="#27A949">Send</vs-button>
              </div>
            </template>
          </vx-input-group>
        </div>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="5" vs-sm="12">
        <img class="univ-header-img" src="../../../../src/assets/images/demo/university-header.png" align="center"/>
      </vs-col>
    </vs-row>
    <img class="leaf-2" src="../../../../src/assets/images/leaves/l13.png" align="right"/>
    <img class="right-texture" src="../../../../src/assets/images/pages/university-header-right-texture.svg"/>
  </header>
</template>

<script>
    export default {
        name: "Header"
    }
</script>

<style scoped>
  .items-center {
    text-align: center;
    text-align: -moz-center;
    text-align: -webkit-center;
  }
  header {
    height: 100vh;
    position: relative;
    background: linear-gradient(104.96deg, #27A949 0.72%, #5CF5C8 94.5%) no-repeat;
  }
  .univ-demo-input {
    width: 70%!important;
  }
  .univ-demo-input >>> input {
    border-radius: 100px 0 0 100px!important;
    background-color: transparent;
    border-color: white!important;
    color: white!important;
  }
  .univ-demo-input >>> .input-span-placeholder {
    color: white!important;
  }
  button {
    border-radius: 100px;
  }
  input {
    border-radius: 100px!important;
  }
  .left-texture {
    position: absolute;
    top: 0;
    height: 100vh;
    width: 60%;
  }
  .right-texture {
    position: absolute;
    top: 0;
    right: 0;
  }
  .leaf-1 {
    position: absolute;
    top: 0;
    left: 0;
    width: 200px;
    z-index: 999;
  }
  .leaf-2 {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 200px;
    z-index: 999;
  }
  .univ-header-img {
    position: absolute;
    height: 80vh;
    top: 100px;
    right: 50px;
    z-index: 999;
  }
  /*header .content {
    padding: 10rem;
  }*/
  .header__content {
    padding: 15rem 0rem 10rem 15rem;
    z-index: 999;
  }
  .header__content .header__p1 {
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 38px;
    /* identical to box height, or 146% */
    letter-spacing: -0.01em;
    color: #FFFFFF;
  }
  .header__content .header__h3 {
    font-style: normal;
    font-weight: 700;
    font-size: 50px;
    line-height: 115%;
    /* or 74px */
    letter-spacing: -0.04em;
    color: #FFFFFF;
  }
  .header__content .header__p2 {
    font-style: normal;
    font-weight: 300;
    font-size: 20px;
    line-height: 38px;
    /* identical to box height, or 146% */
    letter-spacing: -0.01em;
    color: #FFFFFF;
  }


  /*===============================================*/
  /* MEDIA QUERIES	 						 */
  /*===============================================*/

  @media (max-width: 1200px) {
    section {
      padding: 5rem 2rem;
      background: #FFFFFF;
    }
    .leaf-1, .leaf-2 {
      width: 150px;
    }
    .univ-header-img {
      width: -webkit-fill-available;
      width: -moz-available;
      margin-bottom: 5rem;
    }
    .header__content {
      padding: 10rem 2rem 5rem 2rem;
      text-align: center;
      text-align: -moz-center;
      text-align: -webkit-center;
    }
    .left-texture {
      width: -webkit-fill-available;
      width: -moz-available;
    }
    .right-texture {
      display: none;
    }
  }
</style>
